import React, { useEffect } from "react";
import { VATInfoModal } from "../flow/modals/VATInfoModal";
import { IVATTypes } from "../typings";
import { useVATStore } from "../stores/VATStore";
import StepCompleteAbstract from "../steps/StepCompleteAbstract";
import { VatHeader } from "./fragments/VatHeader";
import { VatActions } from "./fragments/VatActions";
import { VatFooter } from "./fragments/VatFooter";
import StepVAT from "./steps/StepVAT";
import StepGCL from "./steps/StepGCL";
import { GCLInfoModal } from "../flow/modals/GCLInfoModal";

const VATFormFlow: React.FC<{}> = () => {
    const { currentStep, vatModal, showVATModal, gclModal, showGCLModal, init } = useVATStore();
    const steps: IVATTypes[] = ['vat_information', 'gcl_information', 'final'];

    useEffect(() => {
        init();
    }, []);

    return (
        <>
            {vatModal ? <VATInfoModal onClose={() => showVATModal(false)} /> : ''}
            {gclModal ? <GCLInfoModal onClose={() => showGCLModal(false)} /> : ''}
            <div id="vat-form">
                <div className="vat-form">
                    <VatHeader steps={steps} />
                    <div className="reg-content">
                        {currentStep === 'vat_information' ? <div className="fade-in"><StepVAT /></div> : ''}
                        {currentStep === 'gcl_information' ? <div className="fade-in"><StepGCL /></div> : ''}
                        {currentStep === 'final' ? <div className="fade-in"><StepCompleteAbstract title="Thank You" subtitle="You have sent us all your information." subtitleLine2="This provides our Care Team with essential information to be able to help in an emergency." /></div> : ''}
                        <VatActions />
                        <VatFooter openGCLModal={() => showGCLModal(true)} />
                    </div>
                </div>
            </div>
        </>);
};

export default VATFormFlow;